import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5767f2ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inputGroup" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "requiredInputSymbol"
}
const _hoisted_4 = { class: "inputContainer" }
const _hoisted_5 = ["id", "type", "placeholder", "data-valid", "disabled", "value"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-eye",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "errorLabel"
}

import {
  ref,
  computed,
  withDefaults,
  watch,
  ComputedRef,
} from 'vue';

//import { IformOptions } from '@/aux/formHandling';

/**
 * Create declarations within template
 */
// -- Props -- //
interface Props {
  //interface Props {
  value?: string | Date | number;
  inputIsValid?: boolean;
  resetValidation?: number;
  inputType?: string;
  errorText?: string;
  placeholderText?: string;
  requiredInput?: boolean | ComputedRef<boolean>;
  inputElementIsDisabled?: boolean;
  label?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FormInputV2',
  props: {
    value: { default: '' },
    inputIsValid: { type: Boolean, default: true },
    resetValidation: { default: 0 },
    inputType: { default: 'text' },
    errorText: { default: 'Invalid input' },
    placeholderText: { default: '' },
    requiredInput: { type: [Boolean, null], default: false },
    inputElementIsDisabled: { type: Boolean, default: false },
    label: { default: '' }
  },
  setup(__props: any) {

const props = __props as { value: string | Date | number, inputIsValid: boolean, resetValidation: number, inputType: string, errorText: string, placeholderText: string, requiredInput: boolean | ComputedRef<boolean>, inputElementIsDisabled: boolean, label: string };

/**
 * Imports
 */



const inputTypeComputed = computed(() => {
  if (props.inputType === 'password') {
    return showPassword.value ? 'text' : 'password';
  }

  return props.inputType;
});

const validInput = computed(() => {
  // If input is of string type => do not visualize correct input if it is empty
  if (typeof props.value === 'string') {
    return props.value.length > 0 && props.inputIsValid;
  }

  return props.inputIsValid;
});

const wrongInput = computed(() => {
  return validationRequired.value && !props.inputIsValid;
});

const labelID = computed(() => {
  return `${props.label.toLowerCase().replace(' ', '_')}_label`;
});

const showPassword = ref<boolean>(false);
const validationRequired = ref<boolean>(false);

watch(
  () => props.resetValidation,
  () => {
    validationRequired.value = false;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: _unref(labelID),
      class: "inputLabel"
    }, [
      _createTextVNode(_toDisplayString(__props.label), 1),
      (__props.requiredInput)
        ? (_openBlock(), _createElementBlock("sup", _hoisted_3, " *"))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("input", {
        id: _unref(labelID),
        type: _unref(inputTypeComputed),
        placeholder: __props.placeholderText,
        class: "inputElement",
        "data-valid": _unref(validInput),
        disabled: __props.inputElementIsDisabled,
        value: __props.value ?? '',
        onInput: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$emit('update:value', ($event?.target as HTMLInputElement).value)
        )),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (validationRequired.value = true)),
        onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (validationRequired.value = true), ["enter"]))
      }, null, 40, _hoisted_5),
      (__props.inputType === 'password')
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "passwordIcon",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showPassword.value = !showPassword.value))
          }, _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    (_unref(wrongInput))
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.errorText), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})